import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import { LoadingScreen } from "./components/loading_screen";
import { IAsyncData } from "./core/models";
import { isLoading } from "./core/redux";
import { Layout } from "./layout";
import { LoginPage } from "./modules/auth/ui/pages/login_page";
import { authRedux } from "./modules/auth/ui/state/state";
import { BudgetMainPage } from "./modules/budget/ui/pages/main_page";
import { ClientHistoryMainPage } from "./modules/client_history/ui/pages/main_page";
import { ClientMainPage } from "./modules/client/ui/pages/main_page";
import { ExpenseMainPage } from "./modules/expense/ui/pages/main_page";
import { ProductHistoryMainPage } from "./modules/product_history/ui/pages/main_page";
import { ProductMainPage } from "./modules/product/ui/pages/main_page";
import { ProfileMainPage } from "./modules/profile/ui/pages/main_page";
import { TransactionMainPage } from "./modules/transaction/ui/pages/main_page";
import { UserMainPage } from "./modules/user/ui/pages/main_page";
import { IAppReduxState } from "./redux/store";
import { ROUTES } from "./routes";

export const Main: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authRedux.actions.checkAuth());
  }, [dispatch]);

  const isLoggedInBranch = useSelector<IAppReduxState, IAsyncData<boolean>>((state) => state.auth.isLoggedIn);
  const loading = isLoading(isLoggedInBranch);

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : isLoggedInBranch.data ? (
        <Layout>
          <Switch>
            <Route path={ROUTES.product}>
              <ProductMainPage />
            </Route>

            <Route path={ROUTES.productHistory}>
              <ProductHistoryMainPage />
            </Route>

            <Route path={ROUTES.client}>
              <ClientMainPage />
            </Route>

            <Route path={ROUTES.clientHistory}>
              <ClientHistoryMainPage />
            </Route>

            <Route path={ROUTES.expense}>
              <ExpenseMainPage />
            </Route>

            <Route path={ROUTES.budget}>
              <BudgetMainPage />
            </Route>

            <Route path={ROUTES.transaction}>
              <TransactionMainPage />
            </Route>

            <Route path={ROUTES.user}>
              <UserMainPage />
            </Route>

            <Route path={ROUTES.profile}>
              <ProfileMainPage />
            </Route>

            <Route path="*">
              <Redirect to={ROUTES.product} />
            </Route>
          </Switch>
        </Layout>
      ) : (
        <Switch>
          <Route path={ROUTES.login}>
            <LoginPage />
          </Route>
          <Route path="*">
            <Redirect to={ROUTES.login} />
          </Route>
        </Switch>
      )}
    </div>
  );
};
